import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPhotoBackgroundLayout = loadable(() => import(/* webpackChunkName: "content/guest/header/photoBackground" */ './PhotoBackground'), 'PhotoBackgroundLayout');
